import React, { useState } from 'react';
import { motion } from 'framer-motion';

const FloatingCallButton = ({ phoneNumber }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };
  
  return (
    <motion.div
      className="fixed bottom-6 right-6 z-50"
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.4 }}
    >
      <motion.button
        className="group flex items-center bg-yellow-400 text-black rounded-full shadow-lg"
        onClick={handleCall}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 400, damping: 15 }}
      >
        {/* Circle with phone icon */}
        <div className="relative p-4 rounded-full">
          {/* Simple inline SVG phone icon */}
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            className="relative z-10"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
          <motion.div 
            className="absolute inset-0 bg-yellow-500 rounded-full"
            initial={{ scale: 0 }}
            animate={{ scale: isHovered ? 1 : 0 }}
            transition={{ duration: 0.3 }}
          />
        </div>
        
        {/* Text label that appears on hover */}
        <motion.div
          className="overflow-hidden"
          initial={{ width: 0, opacity: 0 }}
          animate={{ 
            width: isHovered ? 'auto' : 0,
            opacity: isHovered ? 1 : 0
          }}
          transition={{ duration: 0.3 }}
        >
          <span className="whitespace-nowrap pr-5 font-medium">
            Call Now
          </span>
        </motion.div>
      </motion.button>
    </motion.div>
  );
};

export default FloatingCallButton;